import React from 'react';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import ErrorIcon from '@mui/icons-material/Error';

// StatusIcon component for notification icon
export default function StatusIcon({ status }) {
  switch (status.toLowerCase()) {
    case 'strong':
      return (
         <ErrorIcon
                      sx={{ ml: 1, fontSize: 24, verticalAlign: 'middle', color: 'var(--error-color)' }}
                      titleAccess="Abnormal value - High severity"
                    />
      );
    case 'moderate':
      return (
         <ReportProblemIcon
                      sx={{ ml: 1, fontSize: 24, verticalAlign: 'middle', color: 'var(--primary-color)' }}
                      titleAccess="Abnormal value - Medium severity"
                    />
         
      );
    case 'mild':
      return (
           <InfoOutlinedIcon
                      sx={{ ml: 1, fontSize: 24, verticalAlign: 'middle', color: 'var(--info-color)' }}
                      titleAccess="Abnormal value - Low severity"
                    />
      );
    default:
      return '';
  }
}
